export default __webpack_public_path__ + "static/media/TIME-AVAX.9a0f707c.svg";